import { render, staticRenderFns } from "./MitHRManagePeoplePage.vue?vue&type=template&id=39f8f26c&scoped=true"
import script from "./MitHRManagePeoplePage.vue?vue&type=script&lang=js"
export * from "./MitHRManagePeoplePage.vue?vue&type=script&lang=js"
import style0 from "./MitHRManagePeoplePage.vue?vue&type=style&index=0&id=39f8f26c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8f26c",
  null
  
)

export default component.exports